import React from 'react';
import Lists from '../containers/Lists'
import Share from '../containers/drop/Share'
import Comments from '../containers/drop/Comments'
import Header from '../components/Header'


const ListPage = () => (

    <div className="page">
        <Header type='listPage' />

        <main className="content">
            <div className="content-center">
                <Lists />
            </div>
        </main>

        <Share />
        <Comments />

    </div>
)

export default ListPage;


// WEBPACK FOOTER //
// ./src/pages/ListPage.js